import { Capacitor } from '@capacitor/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';
import { Browser } from '@capacitor/browser';
import { Preferences } from '@capacitor/preferences';

//Log in to web session
export async function syncLoginToWeb(ajaxUrl, accessToken, lang = 'fi') {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
  
    if (!ajaxUrl || !accessToken) {
      console.warn('ajaxUrl or accessToken missing');
      return;
    }
  
    try {
      const loginUrl = `${ajaxUrl}?action=inappbrowser&access_token=${encodeURIComponent(accessToken)}&lang=${lang}`;
      const options = 'location=no,hidden=yes,clearcache=no';
  
      const browserRef = InAppBrowser.create(loginUrl, '_blank', options);
  
      browserRef.on('loadstop').subscribe((event) => {
        if (event.url.includes('action=inappbrowser')) {
          browserRef.close();
        }
      });
  
    } catch (error) {
      console.error('[syncLoginToWeb] Error in InAppBrowser:', error);
    }
}

export async function syncLoginToSystemBrowser(ajaxUrl, accessToken, lang = 'fi') {
    if (!Capacitor.isNativePlatform()) return;
    if (!ajaxUrl || !accessToken) return;
    const { value: syncedToken } = await Preferences.get({ key: 'browser_synced_token' });
    if (syncedToken === accessToken) return;

    try {
        const loginUrl = `${ajaxUrl}?action=inappbrowser&access_token=${encodeURIComponent(accessToken)}&lang=${lang}`;

        let resolveLogin;
        const loginDone = new Promise((resolve) => { resolveLogin = resolve; });

        const listener = await Browser.addListener('browserPageLoaded', async () => {
            await listener.remove();
            await Browser.close();
            resolveLogin();
        });

        await Browser.open({ url: loginUrl });
        await loginDone;
        await Preferences.set({ key: 'browser_synced_token', value: accessToken });
    } catch (error) {
        console.error('[syncLoginToSystemBrowser] Error:', error);
    }
}

export async function resetSystemBrowserSync() {
    await Preferences.remove({ key: 'browser_synced_token' });
}

export async function syncLogoutFromWeb(ajaxUrl) {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    const logoutUrl = `${ajaxUrl}?action=logout&applogout=1`;
    const options = 'location=no,hidden=yes';
    const browserRef = InAppBrowser.create(logoutUrl, '_blank', options);

    browserRef.on('loadstop').subscribe((event) => {
      if (event.url.includes('?action=logout')) {
        browserRef.close();
      }
    });
  } catch (error) {
    console.error('[syncLogoutFromWeb] Error in InAppBrowser:', error);
  }
}